import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import type { CoverLotData } from '@/components/CatalogBannerExperiment/components/HeaderImageCluster/types';

import {
    CoverLotImage,
    THUMB_IMAGE_SIZE,
} from '@/components/CatalogBannerExperiment/components/HeaderImageCluster/CoverLotImage';
import { useTrackItemCardClicked } from '@/utils/amplitude/analytics';

type Props = {
    coverLots: CoverLotData[];
    doneOverlay: ReactNode;
    trackItemCardClicked: ReturnType<typeof useTrackItemCardClicked>;
};

export const MobileImageCluster = ({ coverLots, doneOverlay, trackItemCardClicked }: Props) => (
    <div className="relative flex w-full overflow-hidden rounded-md border border-border-secondary bg-background-primary">
        {coverLots.map((lot, index) => (
            <div
                key={lot.itemId}
                className={cn(
                    'flex flex-1 items-center justify-center',
                    index < coverLots.length - 1 && 'border-r border-border-secondary'
                )}
            >
                <CoverLotImage
                    alt={lot.title}
                    catalogId={lot.catalogId}
                    href={lot.url}
                    imageSize={THUMB_IMAGE_SIZE}
                    itemId={lot.itemId}
                    promoted={lot.promoted}
                    src={lot.image}
                    srcSet={`${lot.imageHighDpi} 2x`}
                    trackItemCardClicked={trackItemCardClicked}
                />
            </div>
        ))}
        {doneOverlay}
    </div>
);
